const AddressesIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23392_147451)">
        <mask
          id="mask0_23392_147451"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <path d="M16 0H0V16H16V0Z" fill="white" />
          <path
            d="M13.8124 5.6875C13.4672 5.6875 13.1874 5.96731 13.1874 6.3125V13.75C13.1874 14.0946 12.9071 14.375 12.5624 14.375H11.3956C11.2424 14.5764 11.0777 14.7793 10.9011 14.9832C10.6995 15.2159 10.4992 15.4312 10.3101 15.625H12.5624C13.5963 15.625 14.4374 14.7839 14.4374 13.75V6.3125C14.4374 5.96731 14.1576 5.6875 13.8124 5.6875Z"
            fill="white"
          />
          <path
            d="M5.09887 14.9832C4.92219 14.7793 4.7575 14.5764 4.60434 14.375H3.4375C3.09287 14.375 2.8125 14.0946 2.8125 13.75V6.3125C2.8125 5.96731 2.53269 5.6875 2.1875 5.6875C1.84231 5.6875 1.5625 5.96731 1.5625 6.3125V13.75C1.5625 14.7839 2.40362 15.625 3.4375 15.625H5.68987C5.50078 15.4312 5.30044 15.2159 5.09887 14.9832Z"
            fill="white"
          />
          <path
            d="M7.0625 10.5859C7.0625 10.0682 7.48225 9.64844 8 9.64844C8.51775 9.64844 8.9375 10.0682 8.9375 10.5859C8.9375 11.1037 8.51775 11.5234 8 11.5234C7.48225 11.5234 7.0625 11.1037 7.0625 10.5859Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_23392_147451)">
          <mask
            id="mask1_23392_147451"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="16"
          >
            <path d="M0 1.90735e-06H16V16H0V1.90735e-06Z" fill="white" />
          </mask>
          <g mask="url(#mask1_23392_147451)">
            <path
              d="M13.8124 5.6875C13.4672 5.6875 13.1874 5.96731 13.1874 6.3125V13.75C13.1874 14.0946 12.9071 14.375 12.5624 14.375H11.3956C11.2424 14.5764 11.0777 14.7793 10.9011 14.9832C10.6995 15.2159 10.4992 15.4312 10.3101 15.625H12.5624C13.5963 15.625 14.4374 14.7839 14.4374 13.75V6.3125C14.4374 5.96731 14.1576 5.6875 13.8124 5.6875Z"
              fill="#212529"
            />
            <path
              d="M5.09887 14.9832C4.92219 14.7793 4.7575 14.5764 4.60434 14.375H3.4375C3.09287 14.375 2.8125 14.0946 2.8125 13.75V6.3125C2.8125 5.96731 2.53269 5.6875 2.1875 5.6875C1.84231 5.6875 1.5625 5.96731 1.5625 6.3125V13.75C1.5625 14.7839 2.40362 15.625 3.4375 15.625H5.68987C5.50078 15.4312 5.30044 15.2159 5.09887 14.9832Z"
              fill="#212529"
            />
            <path
              d="M15.125 7.375L8 1.1875L0.875 7.375"
              stroke="#212529"
              strokeWidth="1.25"
              strokeMiterlimit="10"
              strokeLinecap="square"
            />
            <path
              d="M7.0625 10.5938C7.0625 10.076 7.48225 9.65625 8 9.65625C8.51775 9.65625 8.9375 10.076 8.9375 10.5938C8.9375 11.1115 8.51775 11.5312 8 11.5312C7.48225 11.5312 7.0625 11.1115 7.0625 10.5938Z"
              fill="#212529"
            />
            <path
              d="M10.9678 10.7832C10.9678 12.8027 7.99974 15.2188 7.99974 15.2188C7.99974 15.2188 5.03174 12.8027 5.03174 10.7832V10.596C5.03174 8.95675 6.36055 7.62784 7.99974 7.62784C9.63896 7.62784 10.9678 8.95675 10.9678 10.596V10.7832Z"
              stroke="#212529"
              strokeWidth="1.25"
              strokeMiterlimit="10"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_23392_147451">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddressesIcon;
